function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#5a7a7d;stroke-linecap:round;stroke-linejoin:round;stroke-width:50px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M566.36,497.37l107.5-310.46A67.71,67.71,0,0,1,760,145.73l13.4,4.71a67.77,67.77,0,0,1,41.19,86.2l-103,343.19s-33.51,134-1.83,152L850.17,571.25a67.67,67.67,0,0,1,92.34-24.19l12.27,7.17A67.75,67.75,0,0,1,979,646.64L811.13,882,674.56,1091.83v47"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M406.38,514.42,428.83,91.59A67.72,67.72,0,0,1,497.26,25l14.21.19A67.75,67.75,0,0,1,578.1,93.62L566.36,497.38"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M274.41,576.09,195.72,159.28A64.78,64.78,0,0,1,248,84.38L261.35,82a64.77,64.77,0,0,1,74.9,52.22l70.13,380.21"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M273.79,576,137.1,314.48A52.83,52.83,0,0,0,69,284.34l-10.34,4a52.82,52.82,0,0,0-30.15,68.1l101,288.81L170.48,892l88.82,205.31"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M436.1,961.1c-3-123.38,153.14-197.92,153.14-197.92"
})));

function SvgRight5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1013.16 1163.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight5);
export default __webpack_public_path__ + "static/media/right-5.2e7d34ee.svg";
export { ForwardRef as ReactComponent };